import { useEffect, useState } from 'react';
import { Button, Tabs, Toast, Typography } from '@douyinfe/semi-ui';
import { useHistory } from '@jupiter/plugin-runtime/router';
import { useRequest, useEventBus } from '@byted/hooks';
import { forumPostService } from '@/api/forumPost';
import { useScope } from '@/hooks/useScope';
import { CreatePostRequest } from '@/typings/open.platform.forum_bff/namespaces/forumpost';
import { SharePost } from '@/components/Post/SharePost';
import { PostType } from '@/typings/fe';
import { BulletinPost } from '@/components/Post/BulletinPost';
import { QuestionPost } from '@/components/Post/QuestionPost';
import { useUserInfo } from '@/hooks/useUserInfo';
import '../index.module.scss';
import { reportCreatePost } from '@/report';
import usePostImageSet from '@/hooks/usePostImageSet';

const fetcher = async (req: CreatePostRequest) => {
  const res = await forumPostService.createPost(req);
  if (res.error) {
    throw new Error(res.message);
  }
  return res.data;
};
export const NewPost = () => {
  const scope = useScope();
  const history = useHistory();
  const { isAdmin, ifLogin } = useUserInfo();
  const [tabKey, setTabKey] = useState<Exclude<PostType, 'all'>>('question');
  const { User } = useUserInfo();
  const { replaceUrl, getExitUris, clearUrlSet } = usePostImageSet();
  const { run, loading } = useRequest(fetcher, {
    auto: false,
    onError(res) {
      Toast.error(res.message);
    },
    onSuccess(res) {
      clearUrlSet();
      history.replace({
        pathname: `/${scope}/post/${res.PostId}`,
      });
    },
  });
  const submitPost = async (req: CreatePostRequest) => {
    const postContent = replaceUrl(req.Html);
    const res = await run({
      ...req,
      Html: postContent,
      Uris: getExitUris(postContent),
    });
    reportCreatePost({
      post_id: res.PostId,
      uid: User?.Id || '',
      post_type: req.Type,
    });
    return res;
  };
  const { trigger } = useEventBus('POST_SUBMIT');

  useEffect(() => {
    if (scope === 'synthesize') {
      history.replace('/mini-app/post/new');
    }
  }, [scope, history]);

  const handleSubmit = () => {
    switch (tabKey) {
      case 'share':
        trigger('share');
        break;
      case 'bulletin':
        trigger('bulletin');
        break;
      case 'question':
        trigger('question');
        break;
      default:
        break;
    }
  };
  return (
    <>
      <div className="mx-auto mt-4 mb-[64px] max-w-[808px]">
        <Typography.Title heading={4}>发帖</Typography.Title>
        <Tabs
          className="post-new-container"
          defaultActiveKey={tabKey}
          lazyRender={true}
          keepDOM={false}
          onChange={key => {
            setTabKey(key as typeof tabKey);
          }}>
          <Tabs.TabPane itemKey="question" tab={'发布问题'}>
            <QuestionPost submitPost={submitPost} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={'发布文章'} itemKey="share">
            <SharePost submitPost={submitPost} />
          </Tabs.TabPane>
          {isAdmin && (
            <Tabs.TabPane tab={'公告'} itemKey={'bulletin'}>
              <BulletinPost submitPost={submitPost} />
            </Tabs.TabPane>
          )}
        </Tabs>
      </div>
      <div
        className={
          'fixed bottom-0 h-16 bg-white w-screen flex items-center justify-center pl-[500px] z-10'
        }>
        <Button
          theme="light"
          type="tertiary"
          className="w-[76px]"
          onClick={() => {
            history.push('/');
          }}>
          取消
        </Button>
        <Button
          disabled={!ifLogin}
          loading={loading}
          htmlType="submit"
          theme="solid"
          type="primary"
          className="ml-3 w-[76px] "
          onClick={handleSubmit}>
          提交
        </Button>
      </div>
    </>
  );
};

export default NewPost;
